import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChannelLinkModel extends Model {
  @attr('string') propertyId!: string | null;
  @attr('string') externalId!: string;
  @attr('string') status!: string | null;

  @belongsTo('channel-connection', { async: false, inverse: 'channelLinks' })
  channelConnection!: ModelRegistry['channel-connection'];

  get needsAttention(): boolean {
    return ['rate_not_syncable', 'room_not_active'].includes(this.status ?? '');
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-link': ChannelLinkModel;
  }
}
